import { GroupAccessType } from '../../../../models/IHierarchyGroupAccess';
import { HrisExpectedColumnType } from '../../../../models/IHrisAttributeModel';

export const getHrisExpectedColumnTypeLabel = (value: HrisExpectedColumnType) => {
	switch (value) {
		case HrisExpectedColumnType.Email:
			return 'Email';
		case HrisExpectedColumnType.EmployeeId:
			return 'Employee Id';
		case HrisExpectedColumnType.FirstName:
			return 'First Name';
		case HrisExpectedColumnType.LastName:
			return 'Last Name';
		case HrisExpectedColumnType.Name:
			return 'Name';
		default:
			throw new Error(`Text for HrisExpectedColumnType: ${value} has not been implemented`);
	}
};

export function GetGroupAccessTypeLabel(type: GroupAccessType) {
	switch (type) {
		case GroupAccessType.AutomaticallyForManagers:
			return 'Automatically For Managers';
		case GroupAccessType.Manual:
			return 'Manually For Managers';
	}
}
